"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Connected16Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M9.5,13 C8.533,13 7.658,12.607 7.024,11.974 C9.643,11.726 11.726,9.643 11.974,7.024 C12.607,7.658 13,8.533 13,9.5 C13,11.433 11.433,13 9.5,13 M6.5,3 C7.467,3 8.342,3.393 8.976,4.026 C6.357,4.274 4.274,6.357 4.026,8.976 C3.393,8.342 3,7.467 3,6.5 C3,4.567 4.567,3 6.5,3 M10,6.5 C10,8.433 8.433,10 6.5,10 C6.344,10 6.196,9.974 6.046,9.954 C6.026,9.804 6,9.656 6,9.5 C6,7.567 7.567,6 9.5,6 C9.656,6 9.804,6.026 9.954,6.046 C9.974,6.196 10,6.344 10,6.5 M11.587,4.413 C10.765,2.411 8.798,1 6.5,1 C3.462,1 1,3.462 1,6.5 C1,8.798 2.411,10.765 4.413,11.587 C5.235,13.589 7.202,15 9.5,15 C12.538,15 15,12.538 15,9.5 C15,7.202 13.589,5.235 11.587,4.413", id: `connected16-${id0}` })),
        react_1.default.createElement("g", { id: "connected-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#connected16-${id0}` })),
            react_1.default.createElement("use", { id: "Page-1", fill: "#000000", xlinkHref: `#connected16-${id0}` })));
}
function Connected16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Connected16Svg, Object.assign({}, svgProps)));
}
exports.default = Connected16;
//# sourceMappingURL=Connected16.js.map